import { TEMPLATE_TYPE } from '@/shared/entities/enums/templateType';

/**
 * Slugs dos templates de movimentação suportados pelo endpoint autenticado
 * `GET /templates/:type/download` do serviço sov-v2-files.
 *
 * Reexporta os valores de movimentação a partir do enum compartilhado
 * `TEMPLATE_TYPE` (fonte única espelhando o backend), mantendo um alias local
 * mais próximo do domínio de movimentação.
 */
export const MOVE_TEMPLATE_TYPE = {
  INCLUSION: TEMPLATE_TYPE.MOVE_INCLUSION,
  EXCLUSION: TEMPLATE_TYPE.MOVE_EXCLUSION,
  ALTERATION: TEMPLATE_TYPE.MOVE_ALTERATION,
  INCLUSION_BRADESCO: TEMPLATE_TYPE.MOVE_INCLUSION_BRADESCO,
  EXCLUSION_BRADESCO: TEMPLATE_TYPE.MOVE_EXCLUSION_BRADESCO,
  INCLUSION_ODONTOPREV: TEMPLATE_TYPE.MOVE_INCLUSION_ODONTOPREV,
} as const;

export type MoveTemplateType = (typeof MOVE_TEMPLATE_TYPE)[keyof typeof MOVE_TEMPLATE_TYPE];
